export interface DailyQuote {
  id: string
  text: string
  source: string
  kind: 'quote' | 'bible'
}

const PROVERBS = [
  '티끌 모아 태산.',
  '천 리 길도 한 걸음부터.',
  '가는 말이 고와야 오는 말이 곱다.',
  '고생 끝에 낙이 온다.',
  '급할수록 돌아가라.',
  '구슬이 서 말이라도 꿰어야 보배다.',
  '돌다리도 두드려 보고 건너라.',
  '등잔 밑이 어둡다.',
  '말 한마디에 천 냥 빚도 갚는다.',
  '백지장도 맞들면 낫다.',
  '서당 개 삼 년이면 풍월을 읊는다.',
  '시작이 반이다.',
  '아는 길도 물어 가라.',
  '웃는 얼굴에 침 못 뱉는다.',
  '원숭이도 나무에서 떨어진다.',
  '윗물이 맑아야 아랫물이 맑다.',
  '작은 고추가 맵다.',
  '콩 심은 데 콩 나고 팥 심은 데 팥 난다.',
  '가랑비에 옷 젖는 줄 모른다.',
  '공든 탑이 무너지랴.',
  '금강산도 식후경이다.',
  '길고 짧은 것은 대어 보아야 안다.',
  '물 들어올 때 노 저어라.',
  '미운 아이 떡 하나 더 준다.',
  '바늘 가는 데 실 간다.',
  '발 없는 말이 천 리 간다.',
  '보기 좋은 떡이 먹기도 좋다.',
  '빈 수레가 요란하다.',
  '쇠뿔도 단김에 빼라.',
  '찬물도 위아래가 있다.',
  '하나를 보면 열을 안다.',
  '호미로 막을 것을 가래로 막는다.',
  '될성부른 나무는 떡잎부터 알아본다.',
  '백문이 불여일견이다.',
  '우물을 파도 한 우물을 파라.',
  '낫 놓고 기역 자도 모른다.',
  '열 손가락 깨물어 안 아픈 손가락 없다.',
  '집에서 새는 바가지는 들에 가도 샌다.',
  '한 술 밥에 배부르랴.',
  '뿌린 대로 거둔다.',
  '좋은 이웃은 먼 친척보다 낫다.',
  '제 눈의 안경이다.',
  '옷깃만 스쳐도 인연이다.',
  '길은 갈 탓, 말은 할 탓이다.',
  '나무는 큰 나무 덕을 못 보아도 사람은 큰사람 덕을 본다.',
  '사공이 많으면 배가 산으로 간다.',
  '세월이 약이다.',
  '손뼉도 마주쳐야 소리가 난다.',
  '열 길 물속은 알아도 한 길 사람 속은 모른다.',
  '가는 정이 있어야 오는 정이 있다.',
] as const

const LIFE_MESSAGES = [
  '오늘 할 수 있는 작은 일부터 시작해요.',
  '천천히 가도 멈추지 않으면 괜찮아요.',
  '평범한 하루가 모여 좋은 삶이 됩니다.',
  '따뜻한 말 한마디가 하루를 밝힙니다.',
  '잘한 일 하나를 스스로 칭찬해 주세요.',
  '마음의 여유는 잠시 멈추는 데서 시작됩니다.',
  '오늘의 수고는 내일의 든든함이 됩니다.',
  '작은 약속을 지키는 일이 큰 믿음을 만듭니다.',
  '서두르지 않아도 나만의 속도로 가면 됩니다.',
  '웃을 일을 하나 찾으면 하루가 가벼워집니다.',
  '고마운 사람에게 먼저 안부를 전해 보세요.',
  '정리된 한 칸이 마음의 여유를 만들어 줍니다.',
  '지금 이 순간에도 충분히 잘하고 있습니다.',
  '오늘의 한 걸음은 어제보다 분명한 전진입니다.',
  '기다림에도 때로는 지혜가 담겨 있습니다.',
  '좋은 하루는 좋은 마음에서 시작됩니다.',
  '작은 친절은 오래 기억되는 선물이 됩니다.',
  '완벽함보다 꾸준함이 더 멀리 데려다줍니다.',
  '쉬어 가는 것도 앞으로 가는 방법입니다.',
  '오늘 만난 사람에게 환한 표정을 건네 보세요.',
  '소중한 것은 가까운 곳에 있을 때가 많습니다.',
  '마음에 담아 둔 고마움을 오늘 표현해 보세요.',
  '한 번의 실수보다 다시 시작하는 용기가 중요합니다.',
  '작은 기쁨을 알아보는 사람이 하루를 풍성하게 만듭니다.',
  '오늘의 햇살처럼 마음도 따뜻하게 열어 두세요.',
  '내가 건넨 좋은 말은 다시 좋은 마음으로 돌아옵니다.',
  '할 일을 하나 마칠 때마다 마음도 가벼워집니다.',
  '지나간 걱정보다 지금의 한 걸음에 마음을 주세요.',
  '가까운 사람의 이야기를 천천히 들어주는 하루가 되세요.',
  '익숙한 하루 속에도 새로 발견할 기쁨이 있습니다.',
  '좋은 기억은 함께 나눌수록 더 따뜻해집니다.',
  '오늘은 어제의 나에게 선물 받은 새로운 하루입니다.',
  '마음이 복잡할 때는 해야 할 일을 하나만 골라 보세요.',
  '수고했다는 말은 나 자신에게도 필요합니다.',
  '작은 변화도 매일 이어지면 큰 차이를 만듭니다.',
  '먼저 웃어 주는 사람이 오늘의 분위기를 바꿉니다.',
  '고마움은 표현할 때 더 오래 남습니다.',
  '나의 속도를 존중하면 하루가 한결 편안해집니다.',
  '오늘의 선택 하나가 좋은 습관의 시작이 됩니다.',
  '정답을 서두르기보다 마음을 차분히 살펴보세요.',
  '함께 나누는 시간은 오래 남는 추억이 됩니다.',
  '어제보다 조금 편안한 오늘이면 충분합니다.',
  '무리하지 않고 꾸준히 이어가는 힘을 믿어 보세요.',
  '좋아하는 일을 잠시 떠올리는 것만으로도 힘이 납니다.',
  '마음을 담은 인사는 하루의 좋은 시작입니다.',
  '한 가지에 집중하면 복잡한 마음이 차분해집니다.',
  '오늘 받은 도움을 다른 사람에게 이어 주세요.',
  '잘 쉬고 다시 시작하는 것도 좋은 선택입니다.',
  '소박한 즐거움을 놓치지 않는 하루가 되세요.',
  '오늘도 내 삶의 소중한 한 페이지입니다.',
] as const

export const DAILY_QUOTES: DailyQuote[] = [
  ...PROVERBS.map((text, index) => ({ id: `proverb-${index + 1}`, text, source: '우리말 속담', kind: 'quote' as const })),
  ...LIFE_MESSAGES.map((text, index) => ({ id: `life-${index + 1}`, text, source: '생활 문구', kind: 'quote' as const })),
]

export const BIBLE_VERSES: DailyQuote[] = [
  { id: 'bible-psalm-23-1', text: '여호와는 나의 목자시니 내가 부족함이 없으리로다.', source: '시편 23:1 · 개역한글', kind: 'bible' },
  { id: 'bible-psalm-46-1', text: '하나님은 우리의 피난처시요 힘이시니 환난 중에 만날 큰 도움이시라.', source: '시편 46:1 · 개역한글', kind: 'bible' },
  { id: 'bible-psalm-37-5', text: '너의 길을 여호와께 맡기라 저를 의지하면 저가 이루시고.', source: '시편 37:5 · 개역한글', kind: 'bible' },
  { id: 'bible-psalm-118-24', text: '이 날은 여호와의 정하신 것이라 이 날에 우리가 즐거워하고 기뻐하리로다.', source: '시편 118:24 · 개역한글', kind: 'bible' },
  { id: 'bible-psalm-119-105', text: '주의 말씀은 내 발에 등이요 내 길에 빛이니이다.', source: '시편 119:105 · 개역한글', kind: 'bible' },
  { id: 'bible-psalm-121-2', text: '나의 도움이 천지를 지으신 여호와에게서로다.', source: '시편 121:2 · 개역한글', kind: 'bible' },
  { id: 'bible-proverbs-3-5', text: '너는 마음을 다하여 여호와를 의뢰하고 네 명철을 의지하지 말라.', source: '잠언 3:5 · 개역한글', kind: 'bible' },
  { id: 'bible-proverbs-16-9', text: '사람이 마음으로 자기의 길을 계획할지라도 그 걸음을 인도하는 자는 여호와시니라.', source: '잠언 16:9 · 개역한글', kind: 'bible' },
  { id: 'bible-matthew-11-28', text: '수고하고 무거운 짐 진 자들아 다 내게로 오라 내가 너희를 쉬게 하리라.', source: '마태복음 11:28 · 개역한글', kind: 'bible' },
  { id: 'bible-john-14-27', text: '평안을 너희에게 끼치노니 곧 나의 평안을 너희에게 주노라.', source: '요한복음 14:27 · 개역한글', kind: 'bible' },
  { id: 'bible-romans-12-12', text: '소망 중에 즐거워하며 환난 중에 참으며 기도에 항상 힘쓰며.', source: '로마서 12:12 · 개역한글', kind: 'bible' },
  { id: 'bible-1-corinthians-13-13', text: '그런즉 믿음, 소망, 사랑, 이 세 가지는 항상 있을 것인데 그 중에 제일은 사랑이라.', source: '고린도전서 13:13 · 개역한글', kind: 'bible' },
  { id: 'bible-galatians-6-9', text: '우리가 선을 행하되 낙심하지 말지니 피곤하지 아니하면 때가 이르매 거두리라.', source: '갈라디아서 6:9 · 개역한글', kind: 'bible' },
  { id: 'bible-philippians-4-4', text: '주 안에서 항상 기뻐하라 내가 다시 말하노니 기뻐하라.', source: '빌립보서 4:4 · 개역한글', kind: 'bible' },
  { id: 'bible-1-thessalonians-5-16', text: '항상 기뻐하라.', source: '데살로니가전서 5:16 · 개역한글', kind: 'bible' },
  { id: 'bible-1-thessalonians-5-17', text: '쉬지 말고 기도하라.', source: '데살로니가전서 5:17 · 개역한글', kind: 'bible' },
  { id: 'bible-1-thessalonians-5-18', text: '범사에 감사하라 이는 그리스도 예수 안에서 너희를 향하신 하나님의 뜻이니라.', source: '데살로니가전서 5:18 · 개역한글', kind: 'bible' },
  { id: 'bible-hebrews-13-8', text: '예수 그리스도는 어제나 오늘이나 영원토록 동일하시니라.', source: '히브리서 13:8 · 개역한글', kind: 'bible' },
  { id: 'bible-1-peter-5-7', text: '너희 염려를 다 주께 맡겨 버리라 이는 저가 너희를 권고하심이니라.', source: '베드로전서 5:7 · 개역한글', kind: 'bible' },
  { id: 'bible-numbers-6-24', text: '여호와는 네게 복을 주시고 너를 지키시기를 원하며.', source: '민수기 6:24 · 개역한글', kind: 'bible' },
]

function getDailyItem(items: DailyQuote[], date: Date): DailyQuote {
  const localDay = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / 86_400_000
  const index = ((localDay % items.length) + items.length) % items.length
  return items[index]
}

export function getDailyQuote(date: Date): DailyQuote {
  return getDailyItem(DAILY_QUOTES, date)
}

export function getDailyBibleVerse(date: Date): DailyQuote {
  return getDailyItem(BIBLE_VERSES, date)
}

export function getDailyContentsByIds(ids: string[]): DailyQuote[] {
  const wanted = new Set(ids)
  return [...DAILY_QUOTES, ...BIBLE_VERSES].filter((quote) => wanted.has(quote.id))
}
